import type React from "react"
import type { PropsWithChildren, ReactNode } from "react"

import { Button } from "./ui/button"

interface RowButtonProps extends PropsWithChildren {
  icon?: React.ReactElement
  suffix?: ReactNode
  onClick: () => void
}

const RowButton = ({ icon, children, onClick, suffix }: RowButtonProps) => {
  return (
    <div className="flex w-full flex-col">
      <Button
        className="flex w-full items-center justify-start gap-3 rounded-none bg-white p-4 font-normal"
        variant="ghost"
        onClick={onClick}
        size="auto"
      >
        {icon} {children}
        {suffix && <div className="ml-auto">{suffix}</div>}
      </Button>
    </div>
  )
}

RowButton.displayName = "RowButton"

export { RowButton }
